// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useIsProjectReadOnly} from '../common/hooks';
import {globalRegistryType} from '../common/utils';
import {Quickstart} from './Quickstart';

type ZeroCollectionsProps = {
  onCreateCollection: () => void;
  registry: globalRegistryType;
};

export const ZeroCollections = ({
  onCreateCollection,
  registry,
}: ZeroCollectionsProps) => {
  const {entityName, registryName, registryProjectName} = registry;
  const {isProjectReadOnly: readOnly} = useIsProjectReadOnly(
    entityName,
    registryProjectName
  );
  return (
    <Tailwind
      style={{
        marginTop: '72px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
      }}>
      <div className="flex w-[850px] flex-col items-center">
        <div className="text-2xl font-normal leading-[1.886rem]">
          Welcome to the {registryName} registry
        </div>
        <div className="mt-24 text-center text-lg font-normal leading-[1.575rem] text-moon-650">
          Publish the best checkpoints from your experiments in W&B to a
          centralized registry. View lineage and action history, automate CI/CD
          processes, and add permissions for version promotion.{' '}
          <div className="break-normal">
            Create a <span className="font-semibold">collection</span> to get
            started!
          </div>
        </div>
        {!readOnly && (
          <Button
            className="create-collection-2 mt-24"
            icon="add-new"
            size="large"
            onClick={onCreateCollection}>
            Create collection
          </Button>
        )}
        <Quickstart
          onCreateCollection={onCreateCollection}
          registry={registry}
        />
      </div>
    </Tailwind>
  );
};
